// Path: src/components/auth/verification/WithVerification.tsx
// Updated to enhance debug logs and ensure EvaluationS rendering
import React from 'react';
import VerificationContainer from './VerificationContainer';
import { useUserStore } from '../../../stores/UserStore';
import { VerificationLevel } from '../../../constants/VerificationLevelEnum';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

const WithVerificationContainer = styled.div`
  animation: fadeIn 1.5s ease-in;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 10px;
    .ant-card,
    .ant-btn {
      font-size: 14px !important;
    }
  }
`;

interface WithVerificationProps {
  [key: string]: any;
}

const withVerification = <P extends object>(Component: React.ComponentType<P>) => {
  const WithVerification: React.FC<P & WithVerificationProps> = (props) => {
    const userStore = useUserStore();
    const isVerified = userStore.verified === VerificationLevel.VERIFIED || userStore.verified === true;

    console.log(
      'WithVerification: Checking verification - userStore.verified:', userStore.verified,
      'isVerified:', isVerified,
      'component:', Component.name,
      'userRole:', userStore.userRole,
      'isLoaded:', userStore.isLoaded
    );

    if (!userStore.isLoaded) {
      console.log('WithVerification: Waiting for userStore to load');
      return <div>Loading...</div>;
    }

    return (
      <WithVerificationContainer className="with-verification">
        <Helmet>
          <title>
            {isVerified ? 'Dashboard' : 'Verification Required'} - OLS
          </title>
          <meta
            name="description"
            content={
              isVerified
                ? 'Access your OLS dashboard for Sun Light Meditation education.'
                : 'Verify your account to access OLS features.'
            }
          />
        </Helmet>
        {isVerified ? (
          <>
            {console.log('WithVerification: Rendering component:', Component.name)}
            <Component {...props} />
          </>
        ) : (
          <>
            {console.log('WithVerification: Rendering VerificationContainer')}
            <VerificationContainer verified={userStore.verified} />
          </>
        )}
      </WithVerificationContainer>
    );
  };
  return WithVerification;
};

export default withVerification;